import {
  Box,
  Text,
  ThemingProps,
  TypographyProps,
  VStack,
  useColorModeValue,
} from '@chakra-ui/react';
import React from 'react';

export type KeyValue = {
  key: string;
  value: string | React.ReactElement | undefined | null;
  elementKey?: string;
  valueColor?: string;
  keyRender?: () => React.ReactElement;
  containerBg?: string;
};

type StyledKeyValuesProps = {
  keyValues: KeyValue[];
  fontSize?: ThemingProps['size'];
  keyFontWeight?: TypographyProps['fontWeight'];
  gap?: number;
  mt?: number;
};

const StyledKeyValues = ({
  keyValues,
  keyFontWeight = 'normal',
  fontSize = 'xs',
  gap = 1.5,
  mt,
}: StyledKeyValuesProps): React.ReactElement => {
  const keyColor = useColorModeValue('gray.500', 'gray.500');
  const fallbackValueColor = useColorModeValue('gray.700', 'gray.50');
  return (
    <VStack mt={mt} fontSize={fontSize} gap={gap} align={'start'}>
      {keyValues.map((keyValue) => {
        return (
          <React.Fragment key={keyValue.elementKey ?? keyValue.key}>
            <Box
              backgroundColor={keyValue.containerBg}
              borderRadius={keyValue.containerBg ? 'md' : undefined}
              padding={keyValue.containerBg ? 1 : undefined}
              w={'100%'}
            >
              {keyValue.keyRender ? (
                keyValue.keyRender()
              ) : (
                <Text fontWeight={keyFontWeight} color={keyColor}>
                  {keyValue.key}
                </Text>
              )}
              <Box
                color={
                  keyValue.valueColor ? keyValue.valueColor : fallbackValueColor
                }
                fontWeight={'bold'}
              >
                {keyValue.value}
              </Box>
            </Box>
          </React.Fragment>
        );
      })}
    </VStack>
  );
};

export default StyledKeyValues;
